const SUBMIT_CHECKOUT_PENDING = "qwizme/checkout/SUBMIT_PENDING";
const SUBMIT_CHECKOUT_SUCCESS = "qwizme/checkout/SUBMIT_SUCCESS";
const SUBMIT_CHECKOUT_FAIL = "qwizme/checkout/SUBMIT_FAIL";
const TOGGLE_PRIZE_SELECTION = "qwizme/checkout/TOGGLE_PRIZE_SELECTION";
const initialState = {
  selectedPrizeId: null,
  pending: false,
  loaded: false,
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case TOGGLE_PRIZE_SELECTION:
      return Object.assign({}, state, {
        selectedPrizeId: state.selectedPrizeId === action.id ? null : action.id
      });
    case SUBMIT_CHECKOUT_PENDING:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case SUBMIT_CHECKOUT_SUCCESS:
      return Object.assign({}, state, {
        error: null
      });
    case SUBMIT_CHECKOUT_FAIL:
      return Object.assign({}, state, {
        error: action.error
      });
    default:
      return state;
  }
}

export function submitCheckoutPending() {
  return {
    type: SUBMIT_CHECKOUT_PENDING
  };
}

export function submitCheckoutSuccess() {
  return {
    type: SUBMIT_CHECKOUT_SUCCESS
  };
}

export function submitCheckoutFail(error) {
  return {
    type: SUBMIT_CHECKOUT_FAIL,
    error
  };
}

export function togglePrizeSelection(id) {
  return {
    type: TOGGLE_PRIZE_SELECTION,
    id
  };
}

export const getSelectedId = state => state.selectedPrizeId;
export const checkoutError = state => state.error;
